import {AsyncInlineError} from '@s-ui/decorators'
import {Repository} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {ComparatorListAdsValueObject} from '../ValueObjects/ComparatorListAdsValueObject.js'

const COMPARATOR_ADS_KEY = 'comparator-ads'

export class SessionStorageAdsRepository extends Repository {
  #storage

  constructor({storage}) {
    super()
    this.#storage = storage
  }

  static create() {
    return new SessionStorageAdsRepository({storage: window.sessionStorage})
  }

  @AsyncInlineError()
  async getComparatorAds() {
    try {
      return ComparatorListAdsValueObject.createFromString({ads: this.#storage.getItem(COMPARATOR_ADS_KEY)})
    } catch (error) {
      return Promise.reject(DomainSharedError.createGenericError({cause: error}))
    }
  }

  @AsyncInlineError()
  async saveComparatorAds({ads: comparatorListAdsValueObject}) {
    try {
      this.#storage.setItem(COMPARATOR_ADS_KEY, JSON.stringify(comparatorListAdsValueObject.ads))
      return Promise.resolve(comparatorListAdsValueObject)
    } catch (error) {
      return Promise.reject(DomainSharedError.createGenericError({cause: error}))
    }
  }

  @AsyncInlineError()
  async clearComparatorAds() {
    try {
      this.#storage.removeItem(COMPARATOR_ADS_KEY)
      return ComparatorListAdsValueObject.empty()
    } catch (error) {
      return Promise.reject(DomainSharedError.createGenericError({cause: error}))
    }
  }
}
